import styled from "styled-components";

export default function Footer(){
    return(
        <Content>
            <p>© {new Date().getFullYear()} Ipanema.org. Todos os direitos reservados.</p>
        </Content>
    )
}

const Content = styled.footer`
    width: 100vw;
    height: 60px;
    background-color: #F8F9FA;

    font-family: 'Poppins', sans-serif;
    display: flex;
    justify-content: center;
    align-items:center;

    text-align: center;
    font-size: 0.9rem;
    color: #000000E6;

    box-sizing: border-box;
    overflow-x: hidden;

    @media (max-width: 600px) {
        font-size: 0.8rem;
    }
`